export const COMMON_LABEL_STYLES = {
  width: 92,
  flexShrink: 0,
  fontSize: "12px",
  fontWeight: "bold",
  color: "text.secondary",
  pt: 1,
};
